// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","cardPicture":"Card_cardPicture__X13cx","cardButton":"Card_cardButton__Rb4jL","cardHead":"Card_cardHead__FgZ+y","voiceCard":"Card_voiceCard__ht8d7"};